import React from 'react';
import { Button } from '@kajabi/sage-react';
import {
  useConfigContext,
  useResultContext,
  useUiResourceContext,
} from 'common/components/CopyMagic/contexts';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';

type Props = {
  fullWidth?: boolean;
};

const ApplyButton = ({ fullWidth = false }: Props) => {
  const { onApply } = useConfigContext();
  const { result } = useResultContext();
  const { loading, setOpen } = useUiResourceContext();
  const trackOnApply = useGeneratorTrackingCallback('useTrackOnApply');
  const trackFeedbackSentiment = useGeneratorTrackingCallback('useTrackFeedbackSentiment');

  const handleClick = () => {
    onApply(result);
    trackOnApply();
    trackFeedbackSentiment({
      contentId: result?.id,
      metaData: result?.meta,
    });
    setOpen(false);
  };

  return (
    <Button
      disabled={!!loading || !result}
      fullWidth={fullWidth}
      color={Button.COLORS.PRIMARY}
      onClick={handleClick}
    >
      Apply
    </Button>
  );
};

export default ApplyButton;
